import type { SxProps, Theme } from '@mui/material'

interface ContainerArgs {
  hasToolbarWithBorder?: boolean
  hasTabletTableView?: boolean
}

export const tableTabletFilterStyles = {
  container: ({ hasToolbarWithBorder, hasTabletTableView }: ContainerArgs): SxProps<Theme> => ({
    borderTopRightRadius: hasToolbarWithBorder ? 0 : 0.5,
    borderTopLeftRadius: hasToolbarWithBorder ? 0 : 0.5,
    ...(hasTabletTableView && {
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: 'gray.12',
    }),
  }),
}
